import { ReactElement } from 'react';
import { percent } from './hrOverviewView';
import classes from './Overview.module.css';

/** High risk first, then moderate. The numbers are written next to it, so the bar is only a picture. */
export const RiskBar = ({
  shares,
}: {
  shares: { high: number; moderate: number };
}): ReactElement => (
  <span className={classes.track} aria-hidden="true">
    <span
      className={classes.level}
      data-level="high"
      style={{ width: percent(shares.high) }}
    />
    <span
      className={classes.level}
      data-level="moderate"
      style={{ width: percent(shares.moderate) }}
    />
  </span>
);
